import React from 'react';
import { motion } from 'framer-motion';
import { Award, Users, Lightbulb, Target } from 'lucide-react';
import './About.css';

const About = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.1,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 24, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };

  const imageVariants = {
    hidden: { y: 32, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 1.1,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };

  const achievements = [
    {
      icon: <Award size={20} />,
      title: "Formação FAAP",
      description: "Desenho Industrial - Design do Produto"
    },
    {
      icon: <Users size={20} />,
      title: "Experiência",
      description: "Larga experiência no trato com cliente"
    },
    {
      icon: <Lightbulb size={20} />,
      title: "Especialização",
      description: "Comunicação Visual e Design Gráfico"
    },
    {
      icon: <Target size={20} />,
      title: "Filosofia",
      description: "Design funcional e objetivo"
    }
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <motion.div
          className="about-content"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-80px' }}
        >
          <div className="about-text">
            <motion.h2 className="section-title" variants={itemVariants}>
              QUEM SOU
            </motion.h2>
            
            <motion.div className="text-content" variants={itemVariants}>
              <p className="intro-text">
                Sou <strong>Designer</strong>, formado em <strong>Desenho Industrial</strong> pela 
                <strong> FAAP – Fundação Armando Álvares Penteado</strong> – em São Paulo, SP – 
                na área de <strong>Design do Produto</strong>.
              </p>
              
              <p>
                Especializei-me em <strong>Comunicação Visual</strong>, exercendo minhas funções 
                profissionais como <strong>Designer Gráfico e de Produtos</strong>, com larga experiência 
                no trato com o cliente, além de desenvolver projetos diversos nesses segmentos.
              </p>
              
              <p>
                Desenvolvo <strong>projetos gráficos</strong>, desde a definição do nome, com o projeto 
                de <strong>Criação de Logotipos</strong>, até o projeto de <strong>Branding</strong> e 
                de <strong>Identidade Visual</strong>.
              </p>
              
              <p className="philosophy">
                Entendo que a função do Design não é unicamente a <strong>Estética</strong>, mas também 
                a <strong>Funcionalidade</strong>, para que a Identidade Visual seja prática e objetiva.
              </p>
            </motion.div>

            <motion.div className="name-signature" variants={itemVariants}>
              <span className="name">João Marcos</span>
              <span className="title">Designer Gráfico</span>
            </motion.div>

            <motion.div className="achievements-grid" variants={itemVariants}>
              {achievements.map((achievement, index) => (
                <motion.div
                  key={index}
                  className="achievement-card"
                >
                  <div className="achievement-icon">
                    {achievement.icon}
                  </div>
                  <div className="achievement-content">
                    <h4>{achievement.title}</h4>
                    <p>{achievement.description}</p>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>

          <motion.div className="about-image" variants={imageVariants}>
            <div className="image-container">
              <div className="image-placeholder">
                <div className="placeholder-content">
                  <img src="/assets/JM.png" alt="João Marcos" />
                </div>
              </div>
              <div className="image-decoration">
                <div className="decoration-circle circle-1"></div>
                <div className="decoration-circle circle-2"></div>
                <div className="decoration-circle circle-3"></div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
